import React from "react"
import { Modal, Button } from "antd"

export default function LogoutModal({ open, onCancel, onConfirm }) {
  return (
    <Modal
      title="Confirm Logout"
      open={open}
      onCancel={onCancel}
      footer={null}
      centered
    >
      <p>Are you sure you want to logout?</p>

      <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
        <Button onClick={onCancel}>
          Cancel
        </Button>

        <Button type="primary" danger onClick={onConfirm}>
          Logout
        </Button>
      </div>
    </Modal>
  )
}